module.exports = __webpack_public_path__ + "static/Dive03-e7b67392533991e58ac0d8cdbec858bf.jpg";